<template>
    <div>
        <div>
            <b-row no-gutters>
                <b-col>
                    <EngagementNav></EngagementNav>
                </b-col>
          </b-row>
        </div>
        <div>
            <div class="engagement-body">
                <b-row>
                    <b-col sm="12" md="8" class="pr-md-0">
                        <div class="engagement-content">
                            <b-row no-gutters>
                                <b-col sm="12" md="4">
                                    <div class="filter-wrapper">
                                        <!--<b-input-group prepend=" ">-->
                                            <!--<b-form-input-->
                                                <!--placeholder="Search"-->
                                                <!--v-on:input="search(true)"-->
                                                <!--v-model="searchString">-->
                                            <!--</b-form-input>-->
                                            <!--<b-dropdown text="Advanced" variant="primary" slot="append">-->
                                                <!--<b-dropdown-item v-for="(category, index) in categories" :value="index" @click="searchOption(index)" :key="index">-->
                                                    <!--{{ category}}-->
                                                    <!--<i v-if="selectedSearchOption ==  index" class="ml-1"> <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">-->
                                                    <!--</i>-->
                                                <!--</b-dropdown-item>-->
                                            <!--</b-dropdown>-->
                                        <!--</b-input-group>-->
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col sm="12" md="4" class="text-right">
                        <b-button variant="primary" class="new-button"
                            @click="newSurvey">
                            + New Survey
                        </b-button>
                    </b-col>
                </b-row>

                <SurveyList
                    @editSurvey="editSurvey"
                    @deleteSurvey="deleteSurvey"
                    @viewSurvey="viewSurvey" />

                <Pagination />

            </div>
        </div>

        <NewSurvey
            :open="survey_modal.new" />

        <EditSurvey
            :open="survey_modal.edit.status" />

        <DeleteSurvey
            :open="survey_modal.delete.status"
            :uuid="del.uuid"
            :title="del.title" />

        <Results
            :open="survey_modal.view.status" />

    </div>
</template>

<script>
import { mapState } from "vuex";

import EngagementNav from "./EngagementNav";
import SurveyList from "./survey/SurveyTable";
import Pagination from "./survey/Pagination";
import NewSurvey from "./survey/NewSurvey";
import EditSurvey from "./survey/EditSurvey";
import DeleteSurvey from "./survey/DeleteSurvey";
import Results from "./survey/Results";

export default {
    name: "Survey",
    components: {
        EngagementNav,
        SurveyList,
        Pagination,
        NewSurvey,
        EditSurvey,
        DeleteSurvey,
        Results
    },
    data() {
        return {
            searchString: "",
            categories: [],
            selectedSearchOption: "0",
            add: {
                open: false
            },
            edit: {
                open: false
            },
            del: {
                open: false,
                uuid: null,
                title: null
            },
            view: {
                open: false
            }
        };
    },
    computed: {
        ...mapState("engagementSurvey", ["survey_modal"])
    },
    methods: {
        searchOption: function(index) {},

        newSurvey: function() {
            this.$store.commit("engagementSurvey/setModal", {
                type: "new",
                status: true
            });
        },
        
        editSurvey: function(uuid) {
            if(uuid) {
                this.edit.open = true;
            }
        },

        deleteSurvey: function(uuid, title) {
            if(uuid) {
                this.del.open = true;
                this.del.uuid = uuid;
                this.del.title = title;
            }
        },

        viewSurvey: function(uuid) {
            if(uuid) {
                this.view.open = true;
            }
        }
    }
}
</script>
